import React from 'react'
import { Button } from '@mui/material'
import { COLOR } from '../../utils/constants/color.constants'

const UiButtonMedium = ({ children, sx, ...props }) => {
  return (
    <Button
      sx={{
        textTransform: 'none',
        fontSize: '14x',
        fontWeight: 500,
        py: '5px',
        px: '15px',
        background: COLOR.GRAY_MEDIUM,
        color: COLOR.WHITE,
        transition: '0.25s all ease-in-out',
        '&:hover': {
          background: COLOR.ORANGE,
          transition: '0.25s all ease-in-out',
        },
        '&.Mui-disabled': {
          background: COLOR.GRAY_LIGHT,
          color: COLOR.WHITE,
          transition: '0.25s all ease-in-out',
        },
        '&.active': {
          background: COLOR.ORANGE,
          transition: '0.25s all ease-in-out',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default UiButtonMedium
